import { createAction } from 'redux-actions'
import { GridFilterModel } from '@mui/x-data-grid-pro'

export const setCheckInsFilterModel = createAction<GridFilterModel>('SET_CHECK_INS_FILTER_MODEL')
export const resetCheckInsFilterModel = createAction('RESET_CHECK_INS_FILTER_MODEL')
